var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPinterest = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0053 12.9149C24.7287 11.6383 22.8936 11 20.8989 11C17.867 11 16.0319 12.2766 14.9947 13.3138C13.7181 14.5904 13 16.266 13 18.0213C13 20.1755 13.8777 21.7713 15.3936 22.4096C15.4734 22.4894 15.633 22.4894 15.7128 22.4894C16.0319 22.4894 16.2713 22.25 16.3511 21.9309C16.4309 21.7713 16.5106 21.2926 16.5904 21.0532C16.6702 20.6543 16.5904 20.4947 16.3511 20.1755C15.9521 19.6968 15.7128 19.0585 15.7128 18.2606C15.7128 15.9468 17.4681 13.4734 20.6596 13.4734C23.2128 13.4734 24.8085 14.9096 24.8085 17.2234C24.8085 18.6596 24.4894 20.016 23.9309 21.0532C23.5319 21.7713 22.8138 22.5692 21.7766 22.5692C21.2979 22.5692 20.8989 22.4096 20.6596 22.0106C20.4202 21.6915 20.3404 21.2926 20.4202 20.8936C20.5 20.4149 20.6596 19.9362 20.8191 19.4575C21.0585 18.5798 21.3777 17.7021 21.3777 17.0638C21.3777 15.9468 20.6596 15.1489 19.6223 15.1489C18.266 15.1489 17.2287 16.5053 17.2287 18.1809C17.2287 19.0585 17.4681 19.617 17.5479 19.8564C17.3883 20.5745 16.3511 24.8032 16.1915 25.5213C16.1117 26 15.3936 29.6702 16.5106 29.9096C17.7074 30.2287 18.8245 26.6383 18.9043 26.2394C18.984 25.9202 19.3032 24.6436 19.4628 23.9255C20.0213 24.484 20.9787 24.883 21.9362 24.883C23.6915 24.883 25.2075 24.0851 26.3245 22.6489C27.3617 21.2926 28 19.3777 28 17.2234C27.9202 15.7872 27.2819 14.1117 26.0053 12.9149Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPinterest);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pinterest.460c84c5e7cd42f466c962ad5cb7f0dc.svg";